import React from 'react';
// import { useAppSelector } from '@/store';
import Answer from './Answer';
import './index.less';
// import assistantIcon from "@/assets/images/assistant.png";
import userIcon from "@/assets/images/ai/user.png";
import ic_agent from "@/assets/images/ai/assistant-avatar.png";
import edit_icon from '@/assets/images/ai/button/edit_icon.png';
import KnowledgeAnswer from './KnowledgeAnswer';
import ActionBar from './ActionBar';
import Failed from './components/Failed';
import Loading from './components/Loading';
import { UOType } from './Answer/type';
import { Tooltip } from 'antd';


interface ChatBlockProps {
  children?: React.ReactNode;
  data: KnowledgeRetrievalOutput;
  hideAvatar?: boolean;
  type?: 'knowledge' | 'itHotline';
  // onButtonClick?: (option, action) => void;
  onResend?: (data: KnowledgeRetrievalOutput) => void;
  onClickFun?: (type: `${UOType}`) => void;
  loadingComponent?: React.ReactNode;
  failedComponent?: React.ReactNode;
  succeededComponent?: React.ReactNode;
  actions?: Array<"copy" | "resend" | "feedback">;
  onEditQuestion?: (ques: string) => void;
  isStreaming?: boolean;
}

export default function ChatBlock(props: ChatBlockProps) {

  const { 
    children,
    data, 
    hideAvatar = false,
    // type = 'knowledge', 
    onResend,
    // onClickFun = () => {},
    loadingComponent = <Loading data={data} />,
    failedComponent = <Failed data={data} onResend={onResend} />, 
    actions = [],
    onEditQuestion,
    isStreaming = false
  } = props;

  // const ddInfo = useAppSelector(state => state.app.ddInfo);
  const ddInfo = {} as any;

  return (
    <div className='chat-block'>
      <div className='chat-block__segment'>
        <div className='chat-block__segment-container'>
          <div className='chat-block__main-container'>
            <div className={`chat-block__left-role ${hideAvatar && 'chat-block_hide_avatar'}`}>
              {data.role === "assistant" && <img src={ic_agent} alt="" className='chat-block__role-img'/>}
            </div>
            <div className='chat-block__middle-text'>
              <div className={`${data.role === "user" ? 'chat-block__middle-text__wrapper user-content' : 'chat-block__middle-text__wrapper'}`}>
                {
                  data.role === "assistant" 
                  ? <div className={`chat-block__middle-text__content ${data.status === "succeeded" ? 'chat-block__middle-text__content_assistant' : ""}`}>
                      {
                        data.status === "loading" 
                        ? loadingComponent 
                        : data.status === "failed" 
                        ? failedComponent
                        // : type === "knowledge" ? (
                        : data.status === "succeeded" ?
                          <>
                            {children}
                            {actions.length > 0 && <ActionBar onResend={onResend} data={data} actions={actions} isStreaming={isStreaming} />}
                          </> : 
                          <>
                            {/* {children} */}
                            <div className='chat-block__abort'>本次回答已被终止</div>
                          </>
                          // )
                        // : (
                        // <Answer data={data} onButtonClick={onButtonClick} />)
                      }
                    </div> 
                  : <div className='chat-block__middle-text__content' style={{backgroundColor: "#D0E2FF" }}>
                    <p>{data.outputs.summary}</p>
                    <div className='user-content-action'>
                      <Tooltip placement='top' title='修改'>
                      <img src={edit_icon} alt="" onClick={() => onEditQuestion?.(data.outputs.summary)}/>
                      </Tooltip>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div className={`chat-block__right-role ${hideAvatar && 'chat-block_hide_avatar'}`}>
              {data.role === "user" && (
                <>
                  {ddInfo?.avatar ? (
                    <img
                      src={ddInfo.avatar}
                      alt=""
                      className="chat-block__role-img"
                    />
                  ) : ddInfo?.name?.length ? (
                    <div className="chat-block__role-name">
                      {ddInfo.name.slice(-2).toUpperCase()}
                    </div>
                  ) : (
                    <img
                      src={userIcon}
                      alt=""
                      className="chat-block__role-img"
                    />
                  )}
                </>
              )}
              {/* {data.role === "user" && <img src={userIcon} alt="" className='chat-block__role-img'/>} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
